import React from 'react';
import './index.css';

const Contact = () => {
  return (
    <section id='contact'>
      <h2>Contact</h2>
      <p>You can find me on:</p> <a href="https://github.com/LaminarPLayer/">GitHub</a><a href="https://www.linkedin.com/in/piotrgrzegorczyk/">LinkedIn</a><a href="https://twitter.com/GrzegorczykP">Twitter</a><p> or you can e-mail me: </p> <a href="mailto:peter.grzegorczyk@gmail.com">peter.grzegorczyk(at)gmail.com</a>
    </section>
  )
}

export default Contact
